import React, {useMemo} from 'react'
import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useProductLists} from '../../hooks/use-product-lists'

import GDICarouselGridBlock from '../optimizely/gdi/layouts/gdiCarouselGridBlock'
import {getSiteEnvVarValue} from '../../utils/site-config'

const WishlistCarousel = () => {
    const styles = useMultiStyleConfig('Cart')
    const {formatMessage} = useIntl()

    const {app: appConfig} = getConfig()
    const {site} = useMultiSite()

    const {data: customer} = useCurrentCustomer()
    const {wishList, isLoading: isListsLoading} = useProductLists()

    const isWishlistCarouselEnabled = getSiteEnvVarValue(appConfig, 'WISHLIST_CAROUSEL_ENABLED', site?.id) === 'true'

    const wishlistProductIds = [...new Set(JSON.parse(wishList?.c_productIDs || '[]').reverse())]

    const shouldHideWishlistCarousel = !isWishlistCarouselEnabled || !customer?.isRegistered || isListsLoading || !wishlistProductIds.length

    if (shouldHideWishlistCarousel) {
        return null
    }

    return (
        <Box
            data-testid="wishlist-carousel"
            {...styles.wishlistCarouselRoot}
        >
            <Text {...styles.wishlistCarouselHeading}>
                {formatMessage({
                    id: 'cart.wishlist_carousel.title',
                    defaultMessage: 'My Wishlist'
                })}
            </Text>

            <GDICarouselGridBlock
                ProductCarouselGridManualContent={wishlistProductIds}
                GDICarouselGridBlockStylesPerViewType={
                    styles.wishlistCarouselGridStyles
                }
                ProductCarouselGridStylesPerViewType={
                    styles.wishlistCarouselProductStyles
                }
                IsWishlistCarousel
            />
        </Box>
    )
}

export default WishlistCarousel